import _styled from "@emotion/styled-base";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { COLORS, BORDER_RADIUS, FONT } from '../../constants';
export var ErrorField =
/*#__PURE__*/
_styled('div', {
  target: "ebb5jg50",
  label: "ErrorField"
})(__assign({
  cursor: 'default',
  width: '100%',
  padding: 8,
  borderBottomLeftRadius: BORDER_RADIUS.medium,
  borderBottomRightRadius: BORDER_RADIUS.medium,
  color: COLORS.white,
  backgroundColor: COLORS.spot.critical,
  fontFamily: FONT.family
}, FONT.sizes.small), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVycm9yRmllbGQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYXdCIiwiZmlsZSI6ImVycm9yRmllbGQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJ2YXIgX19hc3NpZ24gPSAodGhpcyAmJiB0aGlzLl9fYXNzaWduKSB8fCBmdW5jdGlvbiAoKSB7XG4gICAgX19hc3NpZ24gPSBPYmplY3QuYXNzaWduIHx8IGZ1bmN0aW9uKHQpIHtcbiAgICAgICAgZm9yICh2YXIgcywgaSA9IDEsIG4gPSBhcmd1bWVudHMubGVuZ3RoOyBpIDwgbjsgaSsrKSB7XG4gICAgICAgICAgICBzID0gYXJndW1lbnRzW2ldO1xuICAgICAgICAgICAgZm9yICh2YXIgcCBpbiBzKSBpZiAoT2JqZWN0LnByb3RvdHlwZS5oYXNPd25Qcm9wZXJ0eS5jYWxsKHMsIHApKVxuICAgICAgICAgICAgICAgIHRbcF0gPSBzW3BdO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiB0O1xuICAgIH07XG4gICAgcmV0dXJuIF9fYXNzaWduLmFwcGx5KHRoaXMsIGFyZ3VtZW50cyk7XG59O1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQ09MT1JTLCBCT1JERVJfUkFESVVTLCBGT05UIH0gZnJvbSAnLi4vLi4vY29uc3RhbnRzJztcbmV4cG9ydCB2YXIgRXJyb3JGaWVsZCA9IHN0eWxlZCgnZGl2JykoX19hc3NpZ24oeyBjdXJzb3I6ICdkZWZhdWx0Jywgd2lkdGg6ICcxMDAlJywgcGFkZGluZzogOCwgYm9yZGVyQm90dG9tTGVmdFJhZGl1czogQk9SREVSX1JBRElVUy5tZWRpdW0sIGJvcmRlckJvdHRvbVJpZ2h0UmFkaXVzOiBCT1JERVJfUkFESVVTLm1lZGl1bSwgY29sb3I6IENPTE9SUy53aGl0ZSwgYmFja2dyb3VuZENvbG9yOiBDT0xPUlMuc3BvdC5jcml0aWNhbCwgZm9udEZhbWlseTogRk9OVC5mYW1pbHkgfSwgRk9OVC5zaXplcy5zbWFsbCkpO1xuIl19 */");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/shared/errorField.js
// module id = 801
// module chunks = 0